export const CLEANUP_ROOMS = ['Living Room', 'Kitchen', 'Bedroom', 'Hallway'];

// Chores stay broad so they fit any home without editing: "one item that is out of place",
// not a named object. The host can still remove a job that does not fit.
export const CLEANUP_TASKS = {
    any: [
        'Put one item back where it belongs',
        'Put three items back where they belong',
        'Put five items back where they belong',
        'Take one item that belongs in another room to that room',
        'Take two items that belong in other rooms to where they go',
        'Pick up one thing from the floor and put it away',
        'Pick up three things from the floor and put them away',
        'Clear one small surface',
        'Clear one table or counter',
        'Tidy one shelf',
        'Tidy one drawer',
        'Close every open drawer and cupboard here',
        'Throw away one piece of rubbish',
        'Throw away three pieces of rubbish',
        'Put one thing in the recycling',
        'Put three things in the recycling',
        'Empty one small bin',
        'Wipe one surface',
        'Wipe two surfaces',
        'Dust one shelf or surface',
        'Wipe one door handle or light switch',
        'Put away one piece of clothing',
        'Put away three pieces of clothing',
        'Fold one item and put it away',
        'Fold three items and put them away',
        'Put one pair of shoes where they belong',
        'Put away one toy, game, or book',
        'Put away three toys, games, or books',
        'Put away anything nobody is using right now',
        'Straighten one stack of things',
        'Straighten everything on one surface',
        'Put one cushion or pillow back in place',
        'Put every cushion and pillow here back in place',
        'Straighten every chair here',
        'Take one cup or dish to the kitchen',
        'Take every cup and dish here to the kitchen',
        'Gather small loose items into one spot',
        'Put loose papers into one neat pile',
        'Put one bag or box where it belongs',
        'Clear a path across the floor',
        'Clear one corner of the floor',
        'Find one thing that is out of place and put it back',
        'Put the lid back on anything left open',
        'Hang up one thing',
        'Put away one cable or charger nobody is using',
        'Straighten one rug or mat',
        'Water one plant, or tidy around it',
        'Make one spot look the way it should',
    ],
    'Living Room': [
        'Put the sofa cushions back in place',
        'Fold one blanket and put it away',
        'Put the remote back where it lives',
        'Clear the coffee table',
        'Put away one game or toy',
        'Put three books or magazines back where they go',
        'Straighten the rug',
        'Pick up everything on the floor by the sofa',
    ],
    Kitchen: [
        'Wipe the table',
        'Wipe one counter',
        'Put away three clean dishes',
        'Put one dirty dish in the sink or dishwasher',
        'Push the chairs in at the table',
        'Clear the table of things that belong elsewhere',
        'Put one food item back in the cupboard or fridge',
        'Hang up or fold the dish towel',
    ],
    Bedroom: [
        'Straighten the bed',
        'Put the pillows back on the bed',
        'Put one piece of dirty laundry in the hamper',
        'Put three pieces of dirty laundry in the hamper',
        'Fold one piece of clean clothing and put it away',
        'Clear the top of the bedside table',
        'Put away one toy or book',
        'Pick up everything on the floor by the bed',
    ],
    Bathroom: [
        'Hang up one towel',
        'Wipe the sink',
        'Put one item back in the cabinet',
        'Put dirty laundry from the floor in the hamper',
        'Line up the bottles by the sink',
        'Straighten the bath mat',
    ],
    Hallway: [
        'Line up the shoes by the door',
        'Hang up one coat or bag',
        'Put away one hat, scarf, or glove',
        'Straighten the doormat',
        'Put the mail or keys in their spot',
        'Clear anything blocking the path to the door',
        'Take one item left by the door to where it belongs',
        'Pair up any loose shoes',
    ],
};
